const Icon = {
  oslogo: 'http://p0q1vpjvw.bkt.clouddn.com/ahnulogo.jpg',
  swipers: [
    { src: 'http://p0q1vpjvw.bkt.clouddn.com/swiper1.jpg' },
    { src: 'http://p0q1vpjvw.bkt.clouddn.com/swiper2.jpg' },
    { src: 'http://p0q1vpjvw.bkt.clouddn.com/swiper3.jpg' },
    { src: 'http://p0q1vpjvw.bkt.clouddn.com/swiper4.jpg' },
    { src: 'http://p0q1vpjvw.bkt.clouddn.com/swiper5.jpg' }
  ]
}
export default Icon



// WEBPACK FOOTER //
// ./src/const/Icon.js